import { render, staticRenderFns } from "./Revocation.vue?vue&type=template&id=c31781c6&scoped=true"
import script from "./Revocation.vue?vue&type=script&lang=ts"
export * from "./Revocation.vue?vue&type=script&lang=ts"
import style0 from "./Revocation.vue?vue&type=style&index=0&id=c31781c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31781c6",
  null
  
)

export default component.exports